import React from 'react';
import CalendarAndEvent from '../../../events/components/CalendarAndEvent';

/**
 * The sessions of an offering — the nights people actually book.
 *
 * A thin wrapper around CalendarAndEvent, exactly as Squads' ScheduleTab is.
 * That component already does list/week/month views, create, edit, delete,
 * recurrence, venue autocomplete and per-event responses, all parameterised by
 * ownerType/ownerId. Rebuilding any of it here would be a second, worse
 * implementation of a working one — and would drift the moment either changed.
 *
 * Sessions are events with owner_type='program', so the offering owns its
 * nights directly and needs no squad to have a schedule.
 *
 * Pricing is deliberately not here. Prices attach to a session or a series and
 * resolve event → series → programme; that lives in the pricing module, not in
 * the calendar.
 */
const ProgramSessionsPanel = ({ program, academyId, isAdmin = true }) => {
  if (!program?.id) return null;

  return (
    <CalendarAndEvent
      ownerType="program"
      ownerId={program.id}
      isMember
      isAdmin={isAdmin}
      academyId={academyId}
      // Reached from settings, so this is the management view: the host is
      // scheduling nights, not saying whether they will turn up to them.
      allowResponses={false}
    />
  );
};

export default ProgramSessionsPanel;
